export default __webpack_public_path__ + "static/sentiment-842035abf04944a4f513725b2f7bcb2c.png";